'use strict';

var formValidation = require('base/components/formValidation');
module.exports = function () {
    $('form.newsletterSubscribe').on('submit', function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                $.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                } else {
                    $('form.newsletterSubscribe').html('<div class="col-sm-12 body-l email-description">' + data.successMsg + '</div>');
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }

                $.spinner().stop();
            }
        });
        return false;
    });
};
